import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { TRANSLATIONS } from "@/lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("eafg_lang") || "es");

  useEffect(() => {
    localStorage.setItem("eafg_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const segments = path.split(".");
      let node = TRANSLATIONS[lang] || TRANSLATIONS.es;
      for (const s of segments) {
        node = node?.[s];
        if (node === undefined) return path;
      }
      return node;
    },
    [lang]
  );

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}

export function pickLocalized(obj, lang, base) {
  return obj[`${base}_${lang}`] ?? obj[`${base}_es`];
}
